const initState = {
  authError: null,
  
  provisionChecked: false,
  provisioned: false,
  ownedCompaniesChecked: false,
  ownedCompanies: []
}

const authReducer = (state = initState, action) => {
  switch(action.type){
    case 'LOGIN_ERROR':
      console.log('login error');
      return {
        ...state,
        authError: action.err !== undefined ? action.err.message : "Login failure"
      }

    case 'PROVISION_CHECKED_SUCCESS':
    console.log('login success');
      return {
        ...state,
        authError: null,
        
        provisionChecked: true,
        provisioned: action.provisioned
      }
      case 'OWNEDCOMPANIES_CHECKED_SUCCESS':
      console.log('login success');
        return {
          ...state,
          authError: null,
          
          
          ownedCompaniesChecked: true,
          
          ownedCompanies: action.ownedCompanies
        }
    case 'LOGIN_SUCCESS':
      console.log('login success');
      return {
        ...state,
        authError: null
      }

    case 'SIGNOUT_SUCCESS':
      console.log('signout success');

      return {
        initState
      }

    case 'SIGNUP_SUCCESS':
      console.log('signup success')
      return {
        ...state,
        provisionChecked: false, //force the provisioning to be checked again after a successful signup
        authError: null
      }

    case 'SIGNUP_ERROR':
      console.log('signup error ' + action.err.message);
      return {
        ...state,
        authError: action.err.message
      }

    default:
      return state
  }
};

export default authReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/authReducer.js